import { defineStore } from "pinia";

export interface PresenceParticipant {
  actor_type: "user" | "client";
  actor_id: number;
  display_name: string;
  role: "Manager" | "Client";
}

export const usePresenceStore = defineStore("presence", {
  state: () => ({
    // Keys in format "actor_type:actor_id" e.g., "user:12"
    onlineUsers: {} as Record<string, boolean>,
  }),

  actions: {
    setOnlineUsers(users: PresenceParticipant[]) {
      const newMap: Record<string, boolean> = {};
      users.forEach((user) => {
        newMap[`${user.actor_type}:${user.actor_id}`] = true;
      });
      this.onlineUsers = newMap;
    },

    addOnlineUser(user: PresenceParticipant) {
      this.onlineUsers[`${user.actor_type}:${user.actor_id}`] = true;
    },

    removeOnlineUser(user: Pick<PresenceParticipant, "actor_type" | "actor_id">) {
      delete this.onlineUsers[`${user.actor_type}:${user.actor_id}`];
    },

    isUserOnline(actorType: string, actorId: number | string | null | undefined): boolean {
      if (actorId === null || actorId === undefined) {
        return false;
      }
      return !!this.onlineUsers[`${actorType}:${actorId}`];
    },
  },
});
